import React, { useRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { apiUrl } from "../services/api";
import "../App.css";

const SVGComponent = ({
  contrat,
  conducteur,
  voiture,
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR");
  };

  return (
    <div
      style={{
        width: "800px",
        height: "1200px",
        color: "black",
        background: "white",
        padding: "20px",
        boxSizing: "border-box",
        fontFamily: "Arial, sans-serif",
        direction: "rtl",
        textAlign: "right",
      }}
    >
      <h1
        style={{
          fontSize: "32px",
          textAlign: "center",
          marginTop: "40px",
          marginBottom: "20px",
        }}
      >
        التزام بتحمل مسؤولية السيارة
      </h1>
      <div
        style={{
          fontSize: "18px",
          lineHeight: "1.3",
        }}
      >
        <p>انا الموقع اسفله :</p>
        <p>
          السيد(ة) : {conducteur?.nom} {conducteur?.prenom}
        </p>
        <p>الحامل(ة) لبطاقة التعريف الوطنية رقم: {conducteur?.num_cin}</p>
        <p>الحامل(ة) لرخصة السياقة رقم: {conducteur?.num_permis}</p>
        <p>الساكن ب : {conducteur?.adresse}</p>
        <p>الھاتف : {conducteur?.num_tel}</p>
        <p>
          اشهد بكل ما تصح به الشهادة قانونیا انني اتحمل جمیع المسؤولية الخاصة
          بالسيارة
        </p>
        <p>المسجلة تحت رقم : {voiture?.matricule}</p>
        <p>الاسم التجاري : {voiture?.marque}</p>
        <p>الصنف : {voiture?.classe}</p>
        <p>النوع : {voiture?.type}</p>
        <p>رقم الاطار الحدیدي : {voiture?.num_chassis}</p>
        <p>تاريخ الاستعمال : {formatDate(voiture?.date_utilisation)}</p>
        <p>حیث اضل انا المسؤول الوحيد عن السيارة من كل الجوانب .</p>
        <p>
          واصرح انني بإمضاءي علي هدا الالتزام اقر بتحمل المسؤولية امام قانون
          السير المعمول به في هدا الباب واتحمل مسؤولیة الحمولةالتي بالسيارة
          وکدلك تحمل کل المصارف في حالة وقوع اي خسائر كيفما كانت بالسيارة
          المدكورة اعلاه
        </p>
        <p>
          ابتداء من تاريخ : {formatDate(contrat?.date_depart)} على الساعة :{" "}
          {contrat?.heure_depart}
        </p>
        <p>
          الى غاية : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; على الساعة :{" "}
        </p>
        <p>حرر بتاريخ : {formatDate(contrat?.date_contrat)}</p>
        <p style={{ textAlign: "center", marginTop: "30px" }}>الامضاء:</p>
      </div>
    </div>
  );
};

const PrintEngagement = () => {
  const [contrat, setContrat] = useState(null);
  const [conducteur, setConducteur] = useState(null);
  const [voiture, setVoiture] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const printRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const contratRes = await axios.get(`${apiUrl}/contrat/${id}`);

        setContrat(contratRes.data[0]);

        if (contratRes.data[0].id_conducteur) {
          const conducteurRes = await axios.get(
            `${apiUrl}/conducteur/${contratRes.data[0].id_conducteur}`
          );
          setConducteur(conducteurRes.data[0]);
        }

        if (contratRes.data[0].id_voiture) {
          const voitureRes = await axios.get(
            `${apiUrl}/voiture/${contratRes.data[0].id_voiture}`
          );
          setVoiture(voitureRes.data);
        }

        console.log(contrat);
        console.log("--------------------------------------");
        console.log(conducteur);
        console.log("--------------------------------------");
        console.log(voiture);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!contrat || !conducteur || !voiture) {
    return (
      <div>
        l'Engagement n'est pas rempli, vérifiez la page conducteur ou la page
        voiture.
      </div>
    );
  }

  return (
    <div>
      <button onClick={handlePrint} className="print-button no-print">
        Imprimer
      </button>
      <div ref={printRef} className="print-container">
        <SVGComponent
          contrat={contrat}
          conducteur={conducteur}
          voiture={voiture}
        />
      </div>
    </div>
  );
};

export default PrintEngagement;
